import {useDispatch, useSelector} from 'react-redux';
import {memberElectionSelector} from '../../redux/selectors/MemberElectionSelector';
import {groupTermLifeRateSelector} from '../../redux/selectors/GroupTermLifeRateSelector';

export const useGroupTermLifeCoverageRemover = () => {
    const memberElection = useSelector(memberElectionSelector);
    const groupTermLifeCoverage = useSelector(groupTermLifeRateSelector);
    const dispatch = useDispatch();

    const removeEnrolledCoverage = (benefitKey) => {
        let benefitKeysToRemove = getBenefitKeysToRemove(benefitKey);

        const dependents = memberElection.familyDemographics.dependents
            .map(dependent => ({
                    ...dependent,
                    coverages: dependent.coverages
                        .filter(dependentCoverageBenefitKey => !benefitKeysToRemove.includes(dependentCoverageBenefitKey))
                })
            );

        dispatch({
            type: 'UPDATE_MEMBER_ELECTION',
            data: {
                enrolledCoverages: memberElection.enrolledCoverages
                    .filter(enrolledCoverage => !benefitKeysToRemove.includes(enrolledCoverage.benefitKey)),
                familyDemographics: {dependents: dependents}
            }
        });
    };

    const getBenefitKeysToRemove = (benefitKey) => {
        let benefitKeysToRemove = [benefitKey];

        if (isEmployeeLevelCoverage(benefitKey)) {
            benefitKeysToRemove.push(
                groupTermLifeCoverage.employeeADnDBenefitKey,
                groupTermLifeCoverage.dependentBenefitKey
            );
        }
        return benefitKeysToRemove;
    };

    const isEmployeeLevelCoverage = (benefitKey) => {
        return benefitKey === groupTermLifeCoverage.benefitKey;
    };

    return (benefitKey) => removeEnrolledCoverage(benefitKey);
};

